import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { AccessParamList } from '../../../typings/Params';
import ActingBodiesDropdown from '../../../components/Dropdowns/ActingBodiesDropdown';

interface Props {
    filters: AccessParamList['ActingBodyCommands'];
    setFilters: React.Dispatch<React.SetStateAction<AccessParamList['ActingBodyCommands']>>;
    textFilter: string;
    setTextFilter: (value: string) => void;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<AccessParamList, 'ActingBodyCommands'>>>();

    const [actingBodyId, setActingBodyId] = useState<number>(filters.actingBodyId ?? 0);

    const handleCleanFilter = () => {
        setActingBodyId(0);
        setTextFilter('');
    };

    const handleFilter = () => {
        navigation.setParams({
            ...filters,
            page: 1,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
        });

        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
        });
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <ActingBodiesDropdown
                value={actingBodyId}
                setValue={setActingBodyId}
                zIndex={4} />
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />
        </Filters>
    );
}


export default Filter;
